import { Box } from '@chakra-ui/react';
import { ErrorAlert } from 'components/shared/ErrorAlert';

interface MvrOrderingBlockedStopProps {
  show: boolean;
}

const STOP_COPY =
  'The selected carrier does not permit broker-initiated MVR ordering. The carrier will obtain and review driving records as part of their underwriting process.\n\nPlease review and confirm with your client that all driving history has been disclosed accurately, as premium, coverage, rating, and eligibility may be subject to change following carrier review.';

const MvrOrderingBlockedStop = ({ show }: MvrOrderingBlockedStopProps) => {
  if (!show) return null;

  return (
    <Box mb={4}>
      <ErrorAlert
        title="Stop - MVR Not Required"
        description={STOP_COPY}
        descriptionWhiteSpace="pre-line"
      />
    </Box>
  );
};

export default MvrOrderingBlockedStop;
